module.exports = __webpack_public_path__ + "static/media/fawaz.dfbc673f.png";